import * as React from 'react'
import * as d3 from 'd3'
import styled, { keyframes } from "styled-components"

const ScanContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  max-height: 45px;
  overflow: hidden;
`

const LineBackground = styled.svg`
  stroke: ${(props) => props.theme.highlightColor};
  stroke-width: 3px;
  fill: none;
  grid-area: 1 / 1 / 2 / 2;
  width: 100%;
`

const ScanAnimation = keyframes`
  from { transform: translateX(50px); }
  to { transform: translateX(1500%); }
`

const ScanBar = styled.div`
  width: 5%;
  border: 2px solid ${(props) => props.theme.highlightColor};
  grid-area: 1 / 1 / 2 / 2;
  margin: .1em;
  animation: ${ScanAnimation} 15s ease-in-out alternate infinite;
  background-color: ${(props) => props.theme.hoverColor};
`

const Scanner = ({data}) => {

  const X = d3.map(data, d => d.step);
  const Y = d3.map(data, d => d.value);

  const marginTop = 10
  const width = 950
  const height = 43
  const xRange = [0, width]
  const yRange = [height, marginTop]

  const xDomain = d3.extent(X);
  const yDomain = [0, d3.max(Y)];

  const xScale = d3.scaleLinear(xDomain, xRange);
  const yScale = d3.scaleLinear(yDomain, yRange);

  const line = d3.line()
    .x(d => xScale(d.step))
    .y(d => yScale(d.value) )

  return (
    <ScanContainer>
      <LineBackground>
        <path d={line(data)} />
      </LineBackground>
      <ScanBar />
    </ScanContainer>
  )
}

export default Scanner
